export default __webpack_public_path__ + "static/media/Whip of Love.1a6f004b.png";